import React, { SVGProps } from 'react';

export const CheckBoxIcon: (props: SVGProps<SVGSVGElement>) => JSX.Element = (
  props
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 20 20"
      fill="white"
      {...props}
    >
      <g clipPath="url(#clip0_2335_4000)">
        <path
          d="M7.75502 15.159L3.20502 10.609C2.93166 10.3356 2.93166 9.89243 3.20502 9.61905L4.19494 8.62909C4.4683 8.35571 4.91154 8.35571 5.1849 8.62909L8.25 11.6942L14.8151 5.12909C15.0885 4.85573 15.5317 4.85573 15.8051 5.12909L16.795 6.11904C17.0683 6.3924 17.0683 6.83561 16.795 7.109L8.74498 15.159C8.47159 15.4324 8.02838 15.4324 7.75502 15.159Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2335_4000">
          <rect width="14" height="10.4388" transform="translate(3 4.92407)" />
        </clipPath>
      </defs>
    </svg>
  );
};
